module.exports = __webpack_public_path__ + "img/ayalda_anda_no.d79c926a.png";